/* eslint-disable jsx-a11y/alt-text */

import { useEffect, useRef, useState } from "react";

import promptStyles from "../styles/components/PromptInputs.module.css";
import styles from "../styles/components/PromptGenerate.module.css";
import common from "../styles/Common.module.css";
import { useDispatch, useSelector } from "react-redux";
import { getImages, startLoraImagePolling } from "../reducers/imagesSlice";
import { addModal, closeAllModals, showLoading } from "../reducers/modalsSlice";
import useCharacter from "../hooks/useCharacter";
import { useParams } from "react-router-dom";
import useApi from "../hooks/useApi";
import plusIcon from "../images/plus-icon.svg";
import {
	addItem,
	clearItems,
	deleteItem,
	updateItem
} from "../reducers/composerSlice";
import CharacterPicker from "./CharacterPicker";
import PromptComposeItem from "./PromptComposeItem";

const PromptCompose = ({ variant, externalLoraPrompt }) => {
	const { id, index } = useParams();
	const [loraPrompt, setLoraPrompt] = useState("");
	const [loraPromptDescription, setLoraPromptDescription] = useState("");
	const [selectedLora, setSelectedLora] = useState(null);
	const [loraAspectRatio, setLoraAspectRatio] = useState(0);
	const characters = useSelector((state) => state.compositions.items);
	const [showLoraPicker, setShowLoraPicker] = useState(false);

	const dispatch = useDispatch();
	const { get} = useApi();

	const {
		GenerateLoraImage,
	  } = useCharacter();

	useEffect(() => {
		if(variant && variant.character){
			dispatch(clearItems());
			let stickyChar = {...variant.character};
			stickyChar.strength = 1.0;
			stickyChar.description = "";
			stickyChar.sticky = true;
			dispatch(addItem(stickyChar));
		}
	}, [variant]);

	useEffect(() => {
		setLoraPrompt(externalLoraPrompt);
	}, [externalLoraPrompt]);

	const handleGenerateLoraImage = () => {
		dispatch(addModal({
			type: "confirm",
			message: "This requires 10 amount of credits. Proceed?",
			onConfirm: GenerateImageFromLora,
		}))
	};

	const GenerateImageFromLora = async () => {
		if(characters.length === 0) return;
		dispatch(showLoading());
		let lora_config = [];
		characters.map((lora) => {
			console.log(lora)
			return lora_config.push({
				id: lora.id,
				strength: lora.strength,
				description: lora.description,
				type: lora.success === true ? "character" : "external",
			});
		})
		
		const response = await GenerateLoraImage(loraPrompt, loraAspectRatio, lora_config);
		dispatch(startLoraImagePolling({ id: response.id, generator_id: id, variant_index:index, get }));
		dispatch(closeAllModals());
	}

	const doShowLoraPicker = () => {
		setShowLoraPicker(true);
	}

	const onCharacterSelected = (character) => {
	//   character.strength = 1.0;
	//   character.description = "";
	//   dispatch(addItem(character));
	  setShowLoraPicker(false);
	}

	const handleRemoveItem = (character) => {
		// if(character.sticky) return;
		dispatch(deleteItem(character.key));
	}
	
	const handleSelectItem = (variantURL, variantIndex) => {
		// setLoraPromptDescription(character.description);
		// setSelectedLora(character);
	}

	const handleUpdateLoraDescription = (e) => {
		setLoraPromptDescription(e.target.value);
		if(selectedLora !== null){
			dispatch(updateItem({key: selectedLora.key, description: e.target.value}));
		}
	}

	return (
		<>
			{showLoraPicker && 
				<CharacterPicker 
					onClose={() => setShowLoraPicker(false)} 
					onSelect={onCharacterSelected}
					usedCharacters={characters}
				/>
			}
			<p className={promptStyles.promptInputTitle}>Prompt</p>
			
			<textarea className={promptStyles.prompt}
				placeholder="Prompt"
				type="text"
				value={loraPrompt}
				onChange={(e) => setLoraPrompt(e.target.value)} />
			
			<p className={promptStyles.promptInputTitle}>Style</p>
			<div className={styles.promptGenerateCharacterContainer}>
			<div className={styles.addStyleButtonContainer}>
				<button
						className={common.addButton}
						onClick={() => doShowLoraPicker()}
						>
						<img src={plusIcon} />
					</button>
				</div>
				{characters.map((character, index) => (
					<PromptComposeItem key={`${character?.id}_${index}`} 
						character={character} 
						onRemove={handleRemoveItem}
						onSelect={handleSelectItem}
						selected={selectedLora && character.key === selectedLora.key}
					/>
				))}
			</div>

			<p className={promptStyles.promptInputTitle}>Description (Optional)</p>
			<textarea className={promptStyles.prompt}
				placeholder="Describe your character"
				type="text"
				value={loraPromptDescription}
				onChange={handleUpdateLoraDescription} />
				
			<div className={promptStyles.promptLoraDetails}>
				<div className={promptStyles.promptLoraDetailsRow}>
					<label>aspect ratio</label>
					<select value={loraAspectRatio} onChange={(e) => setLoraAspectRatio(e.target.value)}>
						<option value="0">1:1</option>
						<option value="1">16:9</option>
						<option value="2">9:16</option>
					</select>
				</div>
				
			</div>
			<button
				className={common.generateButton}
				onClick={handleGenerateLoraImage}
			>
				Generate (O 10 credits )
			</button>
		</>
		
	);
};

export default PromptCompose;
